<p class="title">Your offers</p>
{#if allItems !== undefined}
  {#if items && items.length > 0}
    <table class="table is-fullwidth is-hoverable">
      <tbody>
        {#each items as item}
          <tr>
            <td style="width:100%;">
              <div
                class="is-pulled-left"
                style="width=60px; margin-right:20px;">
                {#if item.data.images?.[0]}
                  <img
                    src={item.data.images[0]}
                    style="max-height:60px;max-width:60px;" />
                {:else}
                  <img
                    src="/assets/img/box.png"
                    style="max-height:60px;max-width:60px; background-color:lightgrey" />
                {/if}
              </div>
              <div
                class="is-flex is-flex-direction-row align-items is-align-items-center"
                style="height:60px;">
                <a href={$url('../offer/' + item.id)}>{item.data.name}</a>
              </div>
            </td>
            <td style="min-width:100px;">
              <div
                class="is-flex is-flex-direction-row align-items is-align-items-center"
                style="height:60px;">
                <span class="tag is-info is-light"
                  >{item.data.status || 'draft'}</span>
              </div>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  {:else}
    <div class="has-text-centered pb-6">
      <p class="block">
        <img
          src="/assets/img/box.png"
          style="max-height:120px;max-width:120px;" />
      </p>
      <p class="block">
        {#if allItems.length == 0}When you're ready, get started by creating
          your first offer.{:else}Are you ready to make your next offer?{/if}
      </p>
      <p class="block">
        <a class="button is-primary" on:click={createOffer}>
          <strong>Create offer</strong>
        </a>
      </p>
    </div>
  {/if}
{/if}

<script lang="ts">
  import { url, goto } from '@sveltech/routify';
  import { appState } from '../../../../lib/appState';
  import { uiState } from '../../../../lib/uiState';
  import { hasActiveSubscription } from '../../../../lib/subscriptionHelper';
  import Premium from '../../offers/_components/Premium.svelte';

  let firebase = window.firebase;

  let allItems: Offer_v2_Doc[];

  $: items = allItems
    ? allItems.filter((item) => item.data.status !== 'ended')
    : undefined;

  get();

  async function get() {
    firebase
      .firestore()
      .collection('offers_v2')
      .where('company', '==', $appState.user!.company)
      .onSnapshot((snap) => {
        allItems = snap.docs.map((doc) => ({
          id: doc.id,
          data: doc.data() as Offer_v2
        }));
      });
  }

  function createOffer() {
    if (hasActiveSubscription($appState.company)) {
      $goto('/business/offers/create');
    } else {
      $uiState.activeModal = {
        component: Premium,
        props: {}
      };
    }
  }
</script>
